export const BackgroundImageOverride = () => {
  return null;
};

export default BackgroundImageOverride;
